import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Helping from "../../helpers/Helping";
import { setErrorFields, clearErrorFields } from "../../helpers/validationHelpers";
import { MESSAGE } from '../../config/index';
import LoadingButton from "../fields/LoadingButton";
import Notification from "../layout/Notification";
import Loader from "../layout/Loader";
import Pagination from "react-js-pagination";
import { addCollection, editCollection } from "../../actions/collection_item_action";
import { getAll as getRewards } from '../../services/rewards.service';
import { getAll as getBadges } from '../../services/badges.service';
import Service from '../../helpers/service';
import { Progress } from 'react-sweet-progress';
import { getAll, destroy } from '../../services/item.service';
import {
    fetchLookups,
    addCategories,
    addTypes
} from "../../actions/lookup_action";
import { API_URL, S3 } from '../../config/urls';
import jQuery from "jquery";
import $ from 'jquery';

const { NOT_FOUND, EMPTY } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: API_URL.ADMIN_COLLECTION_API + "collection",
            pageTitle: "Add new collection",
            buttonTitle: "Save",
            collections: [],
            rewards: [],
            badges: [],
            items: [],
            selectedItems: {},
            name: "",
            code: "",
            search: "",
            reward_search: props.reward_search,
            badge_search: props.badge_search,
            activePage: 1,
            reward_activePage: 1,
            badge_activePage: 1,
            limit: 10,
            reward_limit: 10,
            badge_limit: 10,
            sorting: 'id',
            sort_type: 'DESC',
            sort_class: 'fa fa-sort-up',
            type: "",
            brand_id: "",
            reward_id: "",
            badge_id: "",
            is_active: true,
            is_awardable: true,
            list_order: "",
            brand_content: {},
            total: 0,
            is_order: false,
            description: "",
            isLoading: true,
            btnIsDisable: false,
            btnIsEnable: false,
            featured_banner_url: "",
            landscape_thumbnail_url: "",
            portrait_thumbnail_url: "",
            banner_url: "",
            featured_banner_urlPercent: 0,
            landscape_thumbnail_urlPercent: 0,
            portrait_thumbnail_urlPercent: 0,
            banner_urlPercent: 0,
            collectionList: {},
            total_rewards: "",
            exp_days: 0,
            expire_at: null,
            is_timeable: false
        };

        this.onUpdate = this.onUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest(), ...Helping.clearModalRequest() });
    }

    componentDidMount() {
        var that = this;
        this.props.addCategories([]);
        this.props.addTypes([]);
        this.props.destroy('items');

        if (!this.props.id) {
            this.setState({
                isLoading: false
            });
        }
        if (this.props.id) {
            let id = this.props.id;

            that.setState({
                pageTitle: 'Edit Collection',
                buttonTitle: 'Update'
            });
            that.getById(id);
        }
        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.setState({
                pageTitle: "Add new collection",
                buttonTitle: 'Save'
            })
            that.props.closeEditModal();
        });

        if (this.props.brands.length === 0) {
            this.props.fetchLookups("BRAND");
        }
    }

    getById(id) {
        var $this = this;
        axios
            .get(this.state.url + `/${id}`, Helping.getConfig()).then(response => {
                let { payload } = response.data;
                let rewards = this.state.rewards;
                let badges = this.state.badges;
                this.getCollectionItemsInfo(payload.items);

                if (payload.brand_id) {
                    this.setBrandContent(Number(payload.brand_id));
                }

                $this.setState({
                    name: payload.name,
                    code: payload.code,
                    description: payload.description,
                    list_order: payload.list_order,
                    reward_id: payload.reward_id,
                    badge_id: payload.badge_id,
                    brand_id: payload.brand_id,
                    type: payload.type,
                    landscape_thumbnail_url: payload.landscape_thumbnail_url ? payload.landscape_thumbnail_url : "",
                    portrait_thumbnail_url: payload.portrait_thumbnail_url ? payload.portrait_thumbnail_url : "",
                    featured_banner_url: payload.featured_banner_url ? payload.featured_banner_url : "",
                    banner_url: payload.banner_url ? payload.banner_url : "",
                    featured_banner_urlPercent: 0,
                    landscape_thumbnail_urlPercent: 0,
                    portrait_thumbnail_urlPercent: 0,
                    banner_urlPercent: 0,
                    is_active: payload.is_active,
                    is_awardable: payload.is_awardable,
                    total_rewards: payload.total_rewards,
                    expire_at: payload.expire_at,
                    exp_days: payload.exp_days,
                    is_timeable: payload.expire_at ? true : false,
                    isLoading: false
                });
                this.setArrayValues(badges, payload.badge, 'badges');
                this.setArrayValues(rewards, payload.reward, 'rewards');
                this.getItems();
            })
            .catch(error => {
                console.log("error while getting data from id: ", error);
                if (error.response) {
                    Helping.redirectToLogin(error);
                    $this.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        isLoading: false
                    });
                }
            });
    }

    getCollectionItemsInfo = (collection) => {
        const items_ids = collection.map(col => { return this.handleCheckBoxChange(true, col.item_id), Number(col.item_id) }, []);
        const url = API_URL.ITEM_URL + 'items-by-ids?ids=' + JSON.stringify(items_ids);

        Service.getCall(url)
            .then(response => {
                let { payload } = response.data;

                this.setState({
                    collections: payload.items
                });
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    this.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        isLoading: false
                    });
                }
            });
    }

    getItems = () => {
        let search = this.state.search;

        if (this.state.brand_id) {
            this.props.getAll(
                this.state.activePage,
                this.state.limit,
                search.trim(),
                this.state.sorting,
                this.state.sort_type,
                this.state.brand_id
            );
        }
    }

    getRewards = () => {
        let search = this.state.reward_search;
        this.props.getRewards(
            this.state.reward_activePage,
            this.state.reward_limit,
            search.trim(),
            this.state.sorting,
            this.state.sort_type
        );
    }

    getBadges = () => {
        let search = this.state.badge_search;
        this.props.getBadges(
            this.state.badge_activePage,
            this.state.badge_limit,
            search.trim(),
            this.state.sorting,
            this.state.sort_type
        );
    }

    getImagePath(value) {
        return S3.URL + `/collections/${value}/` + Helping.removeSpacialCharactersOtherThanNumbersFromString(this.state.code, false).toLowerCase() + ".jpg";
    }

    handleCheckBoxChange = (checked, value) => {
        let { collectionList } = this.state, collectionItemList = {};
        if (checked) {
            collectionItemList = { ...collectionList, [value]: 0 };
        } else {
            const { [value]: foo, ...rest } = collectionList;
            collectionItemList = { ...rest };
        }
        this.setState({
            collectionList: collectionItemList
        });
    }

    handleSelectedItemsChange = (checked, value) => {
        let { selectedItems } = this.state, collectionItemList = {};

        if (checked) {
            collectionItemList = { ...selectedItems, [value]: 0 };
        } else {
            const { [value]: foo, ...rest } = selectedItems;
            collectionItemList = { ...rest };
        }
        this.setState({
            selectedItems: collectionItemList
        });
    }

    handleValueChange = (e) => {
        const { name, value } = e.target;

        if (name === "name") this.validateFields("string", name, value, "", 100);
        if (name === "code") this.validateFields("string", name, value);
        if (name === "list_order") this.validateFields("numeric", name, value, "", 3);
        if (name === "description") this.validateFields("string", name, value, "", 3);
        if (name === "total_rewards") this.validateFields("numeric", name, value, "", 3);
        if (name === "type") this.validateFields("string", name, value);
        if (name === "exp_days") this.validateFields("numeric", name, value, "", 1);
        if (name === "brand_id") {
            this.validateFields("numeric", name, value);
            this.setBrandContent(Number(value));
        }
        if (name === "landscape_thumbnail_url")
            this.validateFields("file", name, e.target.files[0], "landscape-thumbnail", "");

        if (name === "portrait_thumbnail_url")
            this.validateFields("file", name, e.target.files[0], "portrait-thumbnail", "");

        if (name === "featured_banner_url")
            this.validateFields("file", name, e.target.files[0], "feature-banner", "");

        if (name === "banner_url")
            this.validateFields("file", name, e.target.files[0], "banner", "");

        this.setState({ [name]: value });
    }

    removeImage = (name, id) => {
        $(`#${id}`).val('');
        
        this.setState({ [name]: "", [`${name}Percent`]: 0 });
    }

    validateFields = async (type, field, value, dependency = "", limit = "", errorField = "") => {
        let stringCase = (type === "string" && limit !== "") ? /^([a-zA-Z0-9 _-]{1,})$/ : /^[ A-Za-z0-9$%_.-]*$/;
        let errorMessageField = "";
        errorField !== "" ? errorMessageField = errorField : errorMessageField = field;

        let message = limit === "" ?
            `${errorMessageField} can only have ${type} type value.`
            :
            type.toLowerCase() === "numeric" ? `${errorMessageField} can only have ${type} type value where the ${value} can be up-to ${limit} digits.` :
                type.toLowerCase() === "string" && limit !== "" ? `${errorMessageField} should be less than ${limit} characters.`
                    : `${errorMessageField} can only have ${type} type value where the ${value} should not be null.`;

        if (type.toLowerCase() === 'string') {
            let errorObject = setErrorFields(field, message);
            if (field === 'description' && value.length < Number(limit)) { return this.setState(errorObject); }
            else if (field === 'name' && value.length > Number(limit)) {
                return this.setState(errorObject);
            }
            else if (field !== 'description' && field !== 'name' && stringCase.test(value) === false) {
                return this.setState(errorObject);
            }
        }

        if (type.toLowerCase() === 'file') {
            const file = value;
            var t = file.type.split('/').pop().toLowerCase();

            if (t != "jpeg" && t != "jpg" && t != "png" && t != "bmp" && t != "gif") {
                let errorObject = setErrorFields(field, "Please select a valid image file");
                return this.setState(errorObject);
            }

            else {
                const code = Helping.removeSpacialCharactersOtherThanNumbersFromString(this.state.code, false).toLowerCase();
                const errorMessField = `error_${field}_message`;

                const response = await Helping.signFile(`collections/${dependency}/${code}.jpg`, file, "image", (res) => {
                    const param = field + 'Percent';
                    if (res.imagePercent) this.setState({ ...this.state, [param]: res.imagePercent });
                },
                    false);
                this.setState({ ...this.state, [field]: response.image, [errorMessField]: "" });
            }
        }

        let clearErrorObject = clearErrorFields(field);
        return this.setState(clearErrorObject);
    }

    handleFileChange = (e) => {
        if (Number(this.state.code.length) === 0) {
            e.preventDefault();
            let element = document.getElementById('collectionCode');
            element.scrollIntoView({ behavior: "smooth" });

            return this.setState({ ...setErrorFields('code', Helping.getMessageString(EMPTY, 'code')) })
        }

        this.handleValueChange(e);
    }

    handleRadioBtnChange = (e, obj) => {
        const { name } = e.target;

        if (name === "reward_id") {
            let rewards = this.state.rewards;
            this.setState({
                [name]: obj.id
            },
                this.setArrayValues(rewards, obj, 'rewards'))
        }
        if (name === "badge_id") {
            let badges = this.state.badges;
            this.setState({
                [name]: obj.id
            },
                this.setArrayValues(badges, obj, 'badges'))
        }
    }

    itemsPageRefreshFunction = (e) => {
        e.preventDefault();

        this.setState({
            search: "",
            activePage: 1
        },
            () => this.getItems());
    }

    handleItemsPageChange = (pageNumber) => {
        if (this.state.activePage === pageNumber) {
            return false;
        }

        this.setState({
            activePage: pageNumber,
            isLoading: false
        },
            () => this.getItems());
    }

    handleItemsLimitChange = (itemsLimit) => {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: false
        }, () => this.getItems());
    }

    handleItemsSearchChange = (e) => {
        let $this = this;

        this.setState(
            {
                search: e.target.value,
                activePage: 1
            },
            () => {
                if ($this.state.search.length > 3) {
                    $this.getItems();
                }

                if ($this.state.search.length === 0) {
                    $this.getItems();
                }
            }
        );
    }

    rewardsPageRefreshFunction = (e) => {
        e.preventDefault();

        this.setState({
            reward_search: "",
            reward_activePage: 1
        },
            () => this.getRewards());
    }

    handleRewardsPageChange = (pageNumber) => {
        if (this.state.reward_activePage === pageNumber) {
            return false;
        }

        this.setState({
            reward_activePage: pageNumber,
            isLoading: false
        },
            () => this.getRewards());
    }

    handleRewardsLimitChange = (itemsLimit) => {
        if (this.state.reward_limit === itemsLimit) {
            return false;
        }
        this.setState({
            reward_limit: itemsLimit,
            reward_activePage: 1,
            isLoading: false
        },
            () => this.getRewards());
    }

    handleRewardsSearchChange = (e) => {
        let $this = this;

        this.setState(
            {
                reward_search: e.target.value,
                reward_activePage: 1
            },
            () => {
                if ($this.state.reward_search.length > 3) {
                    $this.getRewards();
                }

                if ($this.state.reward_search.length === 0) {
                    $this.getRewards();
                }
            }
        );
    }

    badgesPageRefreshFunction = (e) => {
        e.preventDefault();

        this.setState({
            badge_search: "",
            badge_activePage: 1
        },
            () => this.getBadges());
    }

    handleBadgesPageChange = (pageNumber) => {
        if (this.state.badge_activePage === pageNumber) {
            return false;
        }

        this.setState({
            badge_activePage: pageNumber,
            isLoading: false
        },
            () => this.getBadges());
    }

    handleBadgesLimitChange = (itemsLimit) => {
        if (this.state.badge_limit === itemsLimit) {
            return false;
        }
        this.setState({
            badge_limit: itemsLimit,
            badge_activePage: 1,
            isLoading: false
        },
            () => this.getBadges());
    }

    handleBadgesSearchChange = (e) => {
        let $this = this;

        this.setState({
            badge_search: e.target.value,
            badge_activePage: 1
        },
            () => {
                if ($this.state.badge_search.length > 3) {
                    $this.getBadges();
                }

                if ($this.state.badge_search.length === 0) {
                    $this.getBadges();
                }
            }
        );
    }

    setBrandContent = (id) => {
        let brand = Helping.getSingle(this.props.brands, id);
        let content = brand ? JSON.parse(brand[0].content) : {};

        this.setState({
            brand_content: { ...content, name: brand[0].name }
        })
        console.log(brand[0].content);
    }

    setArrayValues = (array, value, name) => {
        array.pop();
        array.push(value);
        this.setState({
            [name]: [...array]
        })
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    modalscrollToTop = () => {
        $('.modal').animate({ scrollTop: 0 }, 'slow');
    }

    removeCollectionFromList = (id) => {
        let collectionToBeRemoved = {};

        this.setState(previousState => {
            let listOfStates = {};
            listOfStates = {
                collections: previousState.collections.filter(collection => {
                    if (collection.id === id) collectionToBeRemoved = { ...collection }
                    return collection.id !== id
                })
            };

            if (listOfStates.collections.length < 1) {
                let errorObject = setErrorFields('', "");
                listOfStates = { ...listOfStates, ...errorObject }
            }

            return {
                ...listOfStates
            }
        })
    }

    addCollectionToList = (collection) => {
        let listOfStates = {};

        this.setState(previousState => {
            listOfStates = {
                collections: previousState.collections.concat(collection)
            };
            if (listOfStates.collections.length > 0) {
                let errorObject = clearErrorFields('collections');
                listOfStates = { ...listOfStates, ...errorObject }
            }
            return {
                ...listOfStates
            }
        },
            () => this.handleCheckBoxChange(true, collection.id));
    }

    addItemToList = (item, checked) => {
        let listOfStates = {};

        this.handleSelectedItemsChange(checked, item.id);

        this.setState(previousState => {
            if (checked) {
                listOfStates = {
                    items: previousState.items.concat(item)
                };
            }
            else {
                listOfStates = {
                    items: Helping.removeItem(previousState.items, item.id)
                };
            }

            if (listOfStates.items.length > 0) {
                let errorObject = clearErrorFields('collections');
                listOfStates = { ...listOfStates, ...errorObject }
            }
            return {
                ...listOfStates
            }
        });
    }

    addItemsInfoToCollection = () => {
        let { collectionList, selectedItems } = this.state, listOfStates = {};
        this.setState({
            btnIsEnable: true
        });

        this.state.items.map(item => this.handleCheckBoxChange(true, item.id));
        this.setState(previousState => {
            listOfStates = {
                collections: previousState.collections.concat(previousState.items),
                collectionList: { ...collectionList, ...selectedItems },
                items: [],
                modal_error_message: "Items successfully added in collection.",
                modal_error_type: "success",
                btnIsEnable: false
            };
            return {
                ...listOfStates
            }
        }, () => this.modalscrollToTop())
    }

    addItemsToCollection = () => {
        const itemIds = this.state.items.map(item => { return Number(item.id) }, []);
        let collectionId = this.props.id;
        let self = this;

        this.setState({
            btnIsEnable: true,
            error_message: "",
            error_type: ""
        });
        let data = {
            collection_id: collectionId,
            itemIds: itemIds,
            type: "add"
        };

        Service.postCall(API_URL.ADMIN_COLLECTION_API + "update-collection-items/", data)
            .then(response => {
                self.props.editCollection(response.data.payload);
                self.addItemsInfoToCollection();
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    self.setState({
                        modal_error_message: error.response.data.message,
                        modal_error_type: "danger",
                        btnIsEnable: false
                    }, () => { this.modalscrollToTop(); });
                }
            });
    }

    removeItemsFromCollection = () => {
        const items_ids = Object.keys(this.state.selectedItems);
        let collectionId = this.props.id,
            self = this;

        this.setState({
            btnIsEnable: true,
            error_message: "",
            error_type: ""
        });
        let data = {
            collection_id: collectionId,
            itemIds: items_ids,
            type: "remove"
        };

        Service.postCall(API_URL.ADMIN_COLLECTION_API + "update-collection-items/", data)
            .then(response => {
                self.props.editCollection(response.data.payload);
                self.removeItemsInfoFromCollection(items_ids);
                self.setState(
                    {
                        modal_error_message: "Items successfully deleted from collection.",
                        modal_error_type: "success",
                        btnIsEnable: false,
                        selectedItems: {}
                    }, () => { window.$('#itemDeleteModal').modal('hide'); this.modalscrollToTop(); }
                );
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    self.setState({
                        modal_error_message: error.response.data.message,
                        modal_error_type: "danger",
                        btnIsEnable: false
                    }, () => { window.$('#itemDeleteModal').modal('hide'); this.modalscrollToTop(); });
                }
            });

    }

    removeItemsInfoFromCollection = (items) => {
        items.map(itemId => {
            this.removeCollectionFromList(Number(itemId));
            this.handleCheckBoxChange(false, itemId);
        });
    }

    resetForm = () => {
        this.setState({
            name: "",
            description: "",
            code: "",
            type: "",
            total_rewards: "",
            exp_days: 0,
            expire_at: "",
            is_timeable: false,
            list_order: "",
            is_active: true,
            is_awardable: true,
            brand_id: "",
            reward_id: "",
            badge_id: "",
            rewards: [],
            badges: [],
            items: [],
            brand_content: {},
            collections: [],
            collectionList: {},
            selectedItems: {},
            landscape_thumbnail_url: "",
            portrait_thumbnail_url: "",
            featured_banner_url: "",
            banner_url: "",
            featured_banner_urlPercent: 0,
            landscape_thumbnail_urlPercent: 0,
            portrait_thumbnail_urlPercent: 0,
            banner_urlPercent: 0,
            btnIsDisable: false,
            btnIsEnable: false,
            error_name_message: '',
            error_code_message: '',
            error_total_rewards_message: '',
            error_type_message: '',
            error_list_order_message: '',
            error_exp_days_message: '',
            error_description_message: '',
            error_brand_id_message: '',
            error_portrait_thumbnail_url_message: "",
            error_landscape_thumbnail_url_message: "",
            error_featured_banner_url_message: "",
            error_banner_url_message: "",
            modal_error_message: "",
            modal_error_type: ""
        }, () => { this.props.destroy('items'); this.scrollToTop() });
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false;

        if (Number(state.name.length) === 0) {
            let errorObject = setErrorFields("name", "Name should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (Number(state.code.length) === 0) {
            let errorObject = setErrorFields("code", "Code should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (Number(state.list_order) < 0) {
            let errorObject = setErrorFields("list_order", "List Order should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.brand_id === "") {
            let errorObject = setErrorFields("brand_id", "Brand should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.type === "") {
            let errorObject = setErrorFields("type", "Type should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        // if (state.landscape_thumbnail_url === "") {
        //     let errorObject = setErrorFields("landscape_thumbnail_url", "Landscape Thumbnail is required.");
        //     this.setState(errorObject);
        //     formHasError = true;
        // }

        // if (state.portrait_thumbnail_url === "") {
        //     let errorObject = setErrorFields("portrait_thumbnail_url", "Potrait Thumbnail is required.");
        //     this.setState(errorObject);
        //     formHasError = true;
        // }

        // if (state.featured_banner_url === "") {
        //     let errorObject = setErrorFields("featured_banner_url", "Featured Banner is required.");
        //     this.setState(errorObject);
        //     formHasError = true;
        // }

        // if (state.banner_url === "") {
        //     let errorObject = setErrorFields("banner_url", "Banner is required.");
        //     this.setState(errorObject);
        //     formHasError = true;
        // }

        if (state.reward_id === "") {
            let errorObject = setErrorFields("reward_id", "Reward is required.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.collections.length < 1) {
            let errorObject = setErrorFields("items", "Select atleast 1 item.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (!this.props.id && state.is_timeable && Number(state.exp_days) < 1) {
            let errorObject = setErrorFields("exp_days", "Expire Days are required when the collection is timeable.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (Number(state.description.length) === 0) {
            let errorObject = setErrorFields("description", "Description should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (Number(state.total_rewards.length) === "") {
            let errorObject = setErrorFields("total_rewards", "Expected Count should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    openItemsModal = (e) => {
        e.preventDefault();

        this.setState({
            items: [],
            selectedItems: this.state.collectionList
        },
        () => { this.getItems(); this.removeNetworkError() })
    }

    openViewModal = (e) => {
        e.preventDefault();

        this.setState({
            selectedItems: {}
        },
            () => { this.removeNetworkError() })
    }

    onSave(e) {
        e.preventDefault();

        let self = this,
            state = this.state,
            formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            name: state.name,
            code: state.code,
            description: state.description,
            list_order: state.list_order ? Number(state.list_order) : 0,
            total_rewards: state.total_rewards ? Number(state.total_rewards) : 0,
            exp_days: state.is_timeable ? Number(state.exp_days) : 0,
            type: state.type,
            is_active: state.is_active,
            is_awardable: state.is_awardable,
            brand_id: Number(state.brand_id),
            reward_id: Number(state.reward_id),
            badge_id: state.badge_id > 0 ? Number(state.badge_id) : null,
            total_items: Number(this.state.collections.length),
            itemIds: Object.keys(this.state.collectionList),
            brand_content: JSON.stringify(this.state.brand_content),
            landscape_thumbnail_url: state.landscape_thumbnail_url ? state.landscape_thumbnail_url : null,
            portrait_thumbnail_url: state.portrait_thumbnail_url ? state.portrait_thumbnail_url : null,
            banner_url: state.banner_url ? state.banner_url : null,
            featured_banner_url: state.featured_banner_url ? state.featured_banner_url : null
            // landscape_thumbnail_url: this.getImagePath('landscape-thumbnail'),
            // portrait_thumbnail_url: this.getImagePath('portrait-thumbnail'),
            // banner_url: this.getImagePath('banner'),
            // featured_banner_url: this.getImagePath('feature-banner')
        };

        axios
            .post(API_URL.ADMIN_COLLECTION_API + "create-collection/", data, Helping.getConfig())
            .then(response => {
                self.props.addCollection(response.data.payload);
                self.setState(
                    {
                        error_message: "Collection created successfully.",
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetForm() }
                );
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    self.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); });
                }
            });
    }

    onUpdate(e) {
        e.preventDefault();

        let self = this,
            state = this.state,
            formHasError = this.checkEmptyInputFields(),
            id = this.props.id;
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            id: Number(id),
            name: state.name,
            code: state.code,
            description: state.description,
            type: state.type,
            is_active: state.is_active,
            is_awardable: state.is_awardable,
            brand_id: Number(state.brand_id),
            reward_id: Number(state.reward_id),
            badge_id: state.badge_id > 0 ? Number(state.badge_id) : null,
            list_order: state.list_order ? Number(state.list_order) : 0,
            total_rewards: state.total_rewards ? Number(state.total_rewards) : 0,
            total_items: Number(this.state.collections.length),
            itemIds: Object.keys(this.state.collectionList),
            brand_content: JSON.stringify(this.state.brand_content),
            landscape_thumbnail_url: this.state.landscape_thumbnail_url ? this.state.landscape_thumbnail_url : null,
            portrait_thumbnail_url: this.state.portrait_thumbnail_url ? this.state.portrait_thumbnail_url : null,
            banner_url: this.state.banner_url ? this.state.banner_url : null,
            featured_banner_url: this.state.featured_banner_url ? this.state.featured_banner_url : null
            // landscape_thumbnail_url: this.getImagePath('landscape-thumbnail'),
            // portrait_thumbnail_url: this.getImagePath('portrait-thumbnail'),
            // banner_url: this.getImagePath('banner'),
            // featured_banner_url: this.getImagePath('feature-banner')
        };

        axios.post(API_URL.ADMIN_COLLECTION_API + "update-collection/", data, Helping.getConfig())
            .then(response => {
                self.props.editCollection(response.data.payload);
                self.setState(
                    {
                        error_message: "Collection updated successfully.",
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetForm() }
                );
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    self.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); });
                }
            });
    }

    render() {
        const { selectedItems, items, collections } = this.state;

        return (
            <>
                <div class="addButton-slide right-slider addNew-collection">
                    <div class="slide-top">
                        <div class="slide-header">
                            <h4 class="title">{Helping.getTitleCase(this.state.pageTitle)}</h4>
                            <span class="caption">Add collection information to your system now.</span>
                        </div>
                        {/* <span class="close-slide">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                        </span> */}
                    </div>

                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }
                    <form action="" class="info">
                        <div class="form-group">
                            <label htmlFor="collectionName">Name</label>
                            <input type="text" class={`form-control ${this.state.error_name_message ? 'error-input' : ''}`} name="name" id="collectionName" value={this.state.name} onChange={(e) => this.handleValueChange(e)} />
                            <span className="error-msg">{this.state.error_name_message}</span>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label htmlFor="collectionCode">Code</label>
                                    <input type="text" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} name="code" id="collectionCode" value={this.state.code} onChange={(e) => this.handleValueChange(e)} />
                                    <span className="error-msg">{this.state.error_code_message}</span>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label htmlFor="totalRewards">Total Rewards</label>
                                    <input type="text" class={`form-control ${this.state.error_total_rewards_message ? 'error-input' : ''}`} name="total_rewards" id="totalRewards" value={this.state.total_rewards} onChange={(e) => this.handleValueChange(e)} />
                                    <span className="error-msg">{this.state.error_total_rewards_message}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label htmlFor="listOrder">List Order</label>
                            <input type="text" class={`form-control ${this.state.error_list_order_message ? 'error-input' : ''}`} name="list_order" id="listOrder" value={this.state.list_order} onChange={(e) => this.handleValueChange(e)} />
                            <span className="error-msg">{this.state.error_list_order_message}</span>
                        </div>

                        <div class="form-group">
                            <label htmlFor="collectionType">Type</label> <br />
                            <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} name="type" aria-label="Default select example" id="collectionType"
                                value={this.state.type} onChange={(e) => this.handleValueChange(e)}
                            >
                                <option value="" selected>Select Type...</option>
                                <option value="FEATURED">FEATURED</option>
                                <option value="SPOTLIGHT">SPOTLIGHT</option>
                                <option value="EXPLORE">EXPLORE</option>
                            </select>
                            <span className="error-msg">{this.state.error_type_message}</span>
                        </div>
                        <div class="form-group">
                            <label htmlFor="categoryDetail">Description</label>
                            <textarea class={`form-control ${this.state.error_description_message ? 'error-input' : ''}`} name="description" value={this.state.description} id="categoryDetail" rows="3" onChange={(e) => this.handleValueChange(e)}></textarea>
                            <span className="error-msg">{this.state.error_description_message}</span>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label htmlFor="">Landscape Image</label>

                                    <div class={`ImgField ${this.state.error_landscape_thumbnail_url_message ? 'error-input' : ''}`}>
                                        {this.state.landscape_thumbnail_url &&
                                            <div className="img-holder">
                                                <span class="remove-img" title="Remove Landscape Image" onClick={() => this.removeImage('landscape_thumbnail_url', 'landscapeUrl')}>&times;</span>
                                                <img src={this.state.landscape_thumbnail_url} alt={this.state.name} />
                                            </div>
                                        }

                                        <label class="imgFieldArea" htmlFor="landscapeUrl">
                                            {!this.state.landscape_thumbnail_url &&
                                                <span class="icon fileImg">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                    </svg>
                                                </span>
                                            }
                                            Click or drag and drop Image here
                                        </label>
                                        <input type="file" id="landscapeUrl" name="landscape_thumbnail_url" class="imgFieldInput" accept="image/*" onChange={(e) => this.handleFileChange(e)} />
                                    </div>
                                    <span className="error-msg">{this.state.error_landscape_thumbnail_url_message}</span>

                                    {this.state.landscape_thumbnail_urlPercent > 0 && (
                                        <Progress percent={this.state.landscape_thumbnail_urlPercent} />
                                    )}
                                    <a class="link mt-2" href={this.state.landscape_thumbnail_url}>{this.state.landscape_thumbnail_url} </a>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label htmlFor="">Portrait Thumbnail</label>

                                    <div class={`ImgField ${this.state.error_portrait_thumbnail_url_message ? 'error-input' : ''}`}>
                                        {this.state.portrait_thumbnail_url &&
                                            <div className="img-holder">
                                                <span class="remove-img" title="Remove Portrait Thumbnail" onClick={() => this.removeImage('portrait_thumbnail_url', 'potraitUrl')}>&times;</span>
                                                <img src={this.state.portrait_thumbnail_url} alt={this.state.name} />
                                            </div>
                                        }

                                        <label class="imgFieldArea" htmlFor="potraitUrl">
                                            {!this.state.portrait_thumbnail_url && (
                                                <span class="icon fileImg">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                    </svg>
                                                </span>
                                            )}
                                            Click or drag and drop Image here
                                        </label>
                                        <input type="file" id="potraitUrl" name="portrait_thumbnail_url" class="imgFieldInput" accept="image/*" onChange={(e) => this.handleFileChange(e)} />
                                    </div>
                                    <span className="error-msg">{this.state.error_portrait_thumbnail_url_message}</span>

                                    {this.state.portrait_thumbnail_urlPercent > 0 && (
                                        <Progress percent={this.state.portrait_thumbnail_urlPercent} />
                                    )}
                                    <a class="link mt-2" href={this.state.portrait_thumbnail_url}>{this.state.portrait_thumbnail_url} </a>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label htmlFor="">Featured Banner</label>

                                    <div class={`ImgField ${this.state.error_featured_banner_url_message ? 'error-input' : ''}`}>
                                        {this.state.featured_banner_url &&
                                            <div className="img-holder">
                                                <span class="remove-img" title="Remove Featured Banner" onClick={() => this.removeImage('featured_banner_url', 'featuredBanner')}>&times;</span>
                                                <img src={this.state.featured_banner_url} alt={this.state.name} />
                                            </div>
                                        }

                                        <label class="imgFieldArea" htmlFor="featuredBanner">
                                            {!this.state.featured_banner_url &&
                                                <span class="icon fileImg">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                    </svg>
                                                </span>
                                            }
                                            Click or drag and drop Image here
                                        </label>
                                        <input type="file" id="featuredBanner" name="featured_banner_url" class="imgFieldInput" accept="image/*" onChange={(e) => this.handleFileChange(e)} />
                                    </div>
                                    <span className="error-msg">{this.state.error_featured_banner_url_message}</span>

                                    {this.state.featured_banner_urlPercent > 0 && (
                                        <Progress percent={this.state.featured_banner_urlPercent} />
                                    )}
                                    <a class="link mt-2" href={this.state.featured_banner_url}>{this.state.featured_banner_url} </a>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label htmlFor="">Banner</label>

                                    <div class={`ImgField ${this.state.error_banner_url_message ? 'error-input' : ''}`}>
                                        {this.state.banner_url &&
                                            <div className="img-holder">
                                                <span class="remove-img" title="Remove Banner" onClick={() => this.removeImage('banner_url', 'bannerUrl')}>&times;</span>
                                                <img src={this.state.banner_url} alt={this.state.name} />
                                            </div>
                                        }

                                        <label class="imgFieldArea" htmlFor="bannerUrl">
                                            {!this.state.banner_url && (
                                                <span class="icon fileImg">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                    </svg>
                                                </span>
                                            )}
                                            Click or drag and drop Image here
                                        </label>
                                        <input type="file" id="bannerUrl" name="banner_url" class="imgFieldInput" accept="image/*" onChange={(e) => this.handleFileChange(e)} />
                                    </div>
                                    <span className="error-msg">{this.state.error_banner_url_message}</span>

                                    {this.state.banner_urlPercent > 0 && (
                                        <Progress percent={this.state.banner_urlPercent} />
                                    )}
                                    <a class="link mt-2" href={this.state.banner_url}>{this.state.banner_url} </a>
                                </div>
                            </div>
                        </div>

                        <div class="form-group-tabs">
                            <div class="category-tabs">
                                <ul class="nav nav-pills">
                                    <li class="tab-item">
                                        <a class={`${this.state.is_timeable ? "" : "active"} ${this.props.id ? "disabled" : ""}`} href="#nonTimeable" data-toggle="tab" onClick={() => this.setState({ is_timeable: false })}>Non Timeable</a>
                                    </li>
                                    <li class="tab-item">
                                        <a class={`${this.state.is_timeable ? "active" : ""} ${this.props.id ? "disabled" : ""}`} href="#timeable" data-toggle="tab" onClick={() => this.setState({ is_timeable: true })}>Timeable</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div class={`tab-pane ${this.state.is_timeable ? "" : "active"}`} id="nonTimeable"></div>
                                <div class={`tab-pane ${this.state.is_timeable ? "active" : ""}`} id="timeable">

                                    {!this.props.id ? (
                                        <div class="form-group">
                                            <label htmlFor="expire">Expire at: </label> <br />
                                            <select class={`form-select ${this.state.error_exp_days_message ? 'error-input' : ''}`} name="exp_days" aria-label="Default select example"
                                                id="expire" value={this.state.exp_days} onChange={(e) => this.handleValueChange(e)}
                                            >
                                                <option value="" selected>Select Expire Days...</option>
                                                <option value="1">1 Day</option>
                                                <option value="3">3 Days</option>
                                                <option value="5">5 Days</option>
                                                <option value="7">7 Days</option>
                                            </select>
                                            <span className="error-msg">{this.state.error_exp_days_message}</span>
                                        </div>
                                    ) : (
                                        <div class="form-group">
                                            <label htmlFor="expireAt">Expire at</label>
                                            <input type="text" class="form-control" id="expireAt" value={Helping.convertTimeToHumanReadableFormat(this.state.expire_at)} disabled />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div class="row switch">
                            <div class="col-6">
                                <div class="form-switch">
                                    <span class="switch-label">Active:</span>
                                    <input type="checkbox" class="check-form-input" id="active"
                                        checked={this.state.is_active ? this.state.is_active : false} onChange={(e) => this.setState({ is_active: e.target.checked })}
                                    />
                                    <label htmlFor="active"></label>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-switch">
                                    <span class="switch-label">Awardable:</span>
                                    <input type="checkbox" class="check-form-input" id="awardable"
                                        checked={this.state.is_awardable ? this.state.is_awardable : false} onChange={(e) => this.setState({ is_awardable: e.target.checked })}
                                    />
                                    <label htmlFor="awardable"></label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label htmlFor="brand">Brand</label>
                            <select class={`form-select ${this.state.error_brand_id_message ? 'error-input' : ''}`} name="brand_id" aria-label="Default select example"
                                id="brand" value={this.state.brand_id} onChange={(e) => this.handleValueChange(e)}
                            >
                                <option value="" selected>Select Brand...</option>

                                {this.props.brands.map((brand, i) => (
                                    <option key={i} value={brand.id}>
                                        {brand.name}
                                    </option>
                                ))}
                            </select>
                            <span className="error-msg">{this.state.error_brand_id_message}</span>
                        </div>

                        <div class="select-items">
                            <div class="select-section">
                                <button class="custom-btn semi-dark-btn sm-btn" data-toggle="modal" data-target="#selectBadges" onClick={(e) => { e.preventDefault(); this.getBadges() }}>Select Badge</button>

                                {this.state.badge_id && (
                                    <div class="table-responsive items-tbl">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Logo</th>
                                                    <th scope="col">Created at</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.badges.map((badge, i) => (
                                                    <tr>
                                                        <td scope="row">{badge.id}</td>
                                                        <td class="name">{badge.name}</td>
                                                        <td>
                                                            <div class="logoImg">
                                                                <img src={badge.logo ? badge.logo : null} alt="" class="img-fluid" />
                                                            </div>
                                                        </td>
                                                        <td>{Helping.convertTimeToHumanReadableFormat(badge.created_at)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            <div class="select-section">
                                <button class="custom-btn semi-dark-btn sm-btn" data-toggle="modal" data-target="#selectRewards" onClick={(e) => { e.preventDefault(); this.getRewards() }}>Select Reward</button>

                                {this.state.reward_id ? (
                                    <div class="table-responsive items-tbl">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Thumbnail</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Code</th>
                                                    <th scope="col">Type</th>
                                                    <th scope="col">Created at</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.rewards.map((reward, i) => {
                                                    let obj = JSON.parse(reward.content);

                                                    return (
                                                        <tr>
                                                            <td scope="row">{reward.id}</td>
                                                            <td>
                                                                <div class="logoImg">
                                                                    <img src={obj.thumbnail_url ? obj.thumbnail_url : null} width="40" height="40" alt="" class="img-fluid" />
                                                                </div>
                                                            </td>
                                                            <td class="name">{obj.name ? obj.name : null}</td>
                                                            <td>{reward.code ? reward.code : null}</td>
                                                            <td>{reward.type}</td>
                                                            <td>{Helping.convertTimeToHumanReadableFormat(reward.created_at)}</td>
                                                        </tr>
                                                    )
                                                }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <Notification
                                        type="danger" message="No reward selected." callback={this.removeNetworkError} />
                                )}
                            </div>

                            <div class="select-section">
                                <div class="d-flex justify-content-between">
                                    <button class="custom-btn semi-dark-btn sm-btn" data-toggle="modal" data-target="#selectItems" onClick={(e) => this.openItemsModal(e)}>Select Items</button>
                                </div>

                                {collections.length > 0 ? (
                                    <div class="table-responsive items-tbl">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Thumbnail</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Code</th>
                                                    {!this.props.id &&
                                                        <th scope="col">Action</th>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {collections.map((collection, i) => (
                                                    <tr key={i}>
                                                        <td scope="row">{collection.id}</td>
                                                        <td>
                                                            <div class="logoImg">
                                                                <img src={collection.thumbnail_url ? collection.thumbnail_url : null} alt="" class="img-fluid" />
                                                            </div>
                                                        </td>
                                                        <td class="name">{collection.name ? collection.name : null}</td>
                                                        <td>{collection.code ? collection.code : null}</td>

                                                        {!this.props.id && (
                                                            <td>
                                                                <div class="action-links">
                                                                    <div class="form-check">
                                                                        <input type="checkbox" class="check-form-input" id="checkbox" checked
                                                                            onChange={(e) => {
                                                                                this.removeCollectionFromList(collection.id);
                                                                                this.handleCheckBoxChange(false, collection.id);
                                                                            }} />
                                                                        <span class="checkmark"></span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <Notification
                                        type="danger" message="No item selected." callback={this.removeNetworkError}
                                    />
                                )}
                            </div>
                            <div class="select-section">
                                {(this.props.id && collections.length > 0) &&
                                    <button class="custom-btn semi-dark-btn sm-btn" data-toggle="modal" data-target="#itemsListView" onClick={(e) => this.openViewModal(e)}>Delete Collection Items</button>
                                }
                            </div>
                        </div>

                        <div class="slide-btn">
                            <div className="float-left">
                                <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                            </div>

                            <div class="float-right">
                                {!this.props.id &&
                                    <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                                }

                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    this.props.id ? (
                                        <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                    ) : (
                                        <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                    )}
                            </div>
                        </div>
                    </form>
                </div>

                {/* ----- Rewards Modal ----- */}
                <div class="actionModal modal fade" id="selectRewards" tabindex="-1" role="dialog" aria-labelledby="selectRewards" aria-hidden="true">
                    <Loader />
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Select Reward</h5>
                            </div>

                            <div class="modal-body">
                                <div class="select-header">
                                    <h4 class="title">Rewards</h4>
                                    <form class="cardheader-search">
                                        <div class="cardsearch">
                                            <span class="search-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999"><path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)"></path></svg>
                                            </span>
                                            <input class="form-control mr-sm-2" type="search" placeholder="Search" value={this.state.reward_search} aria-label="Search" onChange={(e) => this.handleRewardsSearchChange(e)} />
                                        </div>
                                        <button class="custom-btn icon-btn semi-dark-btn sm-btn" onClick={(e) => this.rewardsPageRefreshFunction(e)}>
                                            <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                            </svg>
                                            <span class="txt-btn">Refresh</span>
                                        </button>
                                    </form>
                                </div>
                                <div class="select-tbl table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Code</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>

                                        {(this.props.reward_total > 0 && !this.props.reward_isLoading) && (
                                            <tbody>
                                                {this.props.rewards.map((reward, i) => (
                                                    <tr key={i}>
                                                        <td scope="row">{reward.id}</td>
                                                        <td>{reward.code ? reward.code : null}</td>
                                                        <td>{reward.type ? reward.type : null}</td>
                                                        <td>
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" id={`customRadio${i}`} name="reward_id" class="custom-control-input"
                                                                    checked={this.state.reward_id === reward.id} onChange={(e) => this.handleRadioBtnChange(e, reward)} />
                                                                <label class="custom-control-label" for={`customRadio${i}`}></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                                {this.props.reward_total > 0 && (
                                    <div class="table-bottom">
                                        <div class="dataTables_length">
                                            <label>Show
                                                <select
                                                    name="userDataTable_length"
                                                    value={this.props.reward_limit}
                                                    onChange={(e) => this.handleRewardsLimitChange(e.target.value)}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select> of {this.props.reward_total}</label>
                                        </div>
                                        <Pagination
                                            // hideFirstLastPages
                                            activePage={this.props.reward_page}
                                            itemsCountPerPage={this.props.reward_limit}
                                            totalItemsCount={this.props.reward_total}
                                            pageRangeDisplayed={5}
                                            onChange={this.handleRewardsPageChange}
                                            itemClass='page-item'
                                            linkClass='page-link'
                                            prevPageText='Pre'
                                            nextPageText='Next'
                                            firstPageText='First'
                                            lastPageText='Last'
                                            innerClass="dataTables_paginate"
                                            linkClass="paginate_button"
                                            activeLinkClass="paginate_button current"
                                            disabledClass="paginate_button disabled"
                                        />
                                    </div>
                                )}

                                {(this.props.reward_total < 1 && !this.props.reward_isLoading) && (
                                    <div class="user-listing-tbl table-responsive">
                                        <Notification
                                            type='danger'
                                            message={Helping.getMessageString(NOT_FOUND, 'rewards')}
                                            callback={this.removeNetworkError}
                                        />
                                    </div>
                                )}
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ----- Badges Modal ----- */}
                <div class="actionModal modal fade" id="selectBadges" tabindex="-1" role="dialog" aria-labelledby="selectBadges" aria-hidden="true">
                    <Loader />
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Select Badge</h5>
                            </div>

                            <div class="modal-body">
                                <div class="select-header">
                                    <h4 class="title">Badges</h4>
                                    <form class="cardheader-search">
                                        <div class="cardsearch">
                                            <span class="search-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999"><path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)"></path></svg>
                                            </span>
                                            <input class="form-control mr-sm-2" type="search" value={this.state.badge_search} placeholder="Search" aria-label="Search" onChange={(e) => this.handleBadgesSearchChange(e)} />
                                        </div>
                                        <button class="custom-btn icon-btn semi-dark-btn sm-btn" onClick={(e) => this.badgesPageRefreshFunction(e)}>
                                            <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                            </svg>
                                            <span class="txt-btn">Refresh</span>
                                        </button>
                                    </form>
                                </div>
                                <div class="select-tbl table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Logo</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        {(this.props.badge_total > 0 && !this.props.badge_isLoading) && (
                                            <tbody>
                                                {this.props.badges.map((badge, i) => (
                                                    <tr key={i}>
                                                        <td scope="row">{badge.id}</td>
                                                        <td>{badge.name}</td>
                                                        <td>
                                                            <div class="logoImg">
                                                                <img src={badge.logo ? badge.logo : null} alt="Badge Logo" width="40" height="40" class="img-fluid" />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" id={`customBadgeRadio${i}`} name="badge_id" class="custom-control-input"
                                                                    checked={this.state.badge_id === badge.id} onChange={(e) => this.handleRadioBtnChange(e, badge)} />
                                                                <label class="custom-control-label" for={`customBadgeRadio${i}`}></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                                )}
                                            </tbody>
                                        )}
                                    </table>
                                </div>

                                {this.props.badge_total > 0 && (
                                    <div class="table-bottom">
                                        <div class="dataTables_length">
                                            <label>Show
                                                <select
                                                    name="userDataTable_length"
                                                    value={this.props.badge_limit}
                                                    onChange={(e) => this.handleBadgesLimitChange(e.target.value)}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select> of {this.props.badge_total}</label>
                                        </div>
                                        <Pagination
                                            // hideFirstLastPages
                                            activePage={this.props.badge_page}
                                            itemsCountPerPage={this.props.badge_limit}
                                            totalItemsCount={this.props.badge_total}
                                            pageRangeDisplayed={5}
                                            onChange={this.handleBadgesPageChange}
                                            itemClass='page-item'
                                            linkClass='page-link'
                                            prevPageText='Pre'
                                            nextPageText='Next'
                                            firstPageText='First'
                                            lastPageText='Last'
                                            innerClass="dataTables_paginate"
                                            linkClass="paginate_button"
                                            activeLinkClass="paginate_button current"
                                            disabledClass="paginate_button disabled"
                                        />
                                    </div>
                                )}

                                {(this.props.badge_total < 1 && !this.props.badge_isLoading) && (
                                    <div class="user-listing-tbl table-responsive">
                                        <Notification
                                            type='danger'
                                            message={Helping.getMessageString(NOT_FOUND, 'badges')}
                                            callback={this.removeNetworkError}
                                        />
                                    </div>
                                )}
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ----- Items Modal ----- */}
                <div class="actionModal modal fade" id="selectItems" tabindex="-1" role="dialog" aria-labelledby="selectItems" aria-hidden="true">
                    <Loader />
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Select Items</h5>
                            </div>

                            <div class="modal-body">
                                <div class="select-header">
                                    <h4 class="title">Items</h4>
                                    <form class="cardheader-search">
                                        <div class="cardsearch">
                                            <span class="search-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999"><path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)"></path></svg>
                                            </span>
                                            <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" value={this.state.search} onChange={(e) => this.handleItemsSearchChange(e)} />
                                        </div>
                                        <button class="custom-btn icon-btn semi-dark-btn sm-btn" onClick={(e) => this.itemsPageRefreshFunction(e)}>
                                            <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                            </svg>
                                            <span class="txt-btn">Refresh</span>
                                        </button>
                                    </form>
                                </div>

                                {this.state.modal_error_message &&
                                    <Notification
                                        type={this.state.modal_error_type}
                                        message={this.state.modal_error_message}
                                        callback={this.removeNetworkError}
                                    />
                                }
                                <div class="select-tbl table-responsive">
                                    {this.props.total > 0 ? (
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Thumnail</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Code</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props.items.map((item, i) => (
                                                    <tr key={i} className={this.state.collectionList[item.id] !== undefined ? "disabled" : ""}>
                                                        <td scope="row">{item.id}</td>
                                                        <td>
                                                            <div class="logoImg">
                                                                <img src={item.thumbnail_url ? item.thumbnail_url : null} alt="Item" class="img-fluid" />
                                                            </div>
                                                        </td>
                                                        <td>{item.name}</td>
                                                        <td>{item.code}</td>
                                                        <td>{item.amount}</td>
                                                        <td>
                                                            <div class="form-check">
                                                                {/* <input type="checkbox" class="check-form-input" id="checkbox" checked={this.state.collectionList[item.id] !== undefined}
                                                                    onChange={(e) => this.addCollectionToList(item)} /> */}
                                                                <input type="checkbox" class="check-form-input" id='checkbox'
                                                                    checked={this.state.selectedItems[item.id] !== undefined}
                                                                    onChange={(e) => this.addItemToList(item, e.target.checked)}
                                                                />
                                                                <span class="checkmark"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <Notification type="danger" message={this.state.brand_id === "" ? "Please select a brand first." : `Items not found.`} callback={this.removeNetworkError} />
                                    )}
                                </div>

                                {this.props.total > 0 && (
                                    <div class="table-bottom">
                                        <div class="dataTables_length">
                                            <label>Show
                                                <select
                                                    name="userDataTable_length"
                                                    value={this.props.limit}
                                                    onChange={(e) => this.handleItemsLimitChange(e.target.value)}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select> of {this.props.total}</label>
                                        </div>
                                        <Pagination
                                            // hideFirstLastPages
                                            activePage={this.props.page}
                                            itemsCountPerPage={this.props.limit}
                                            totalItemsCount={this.props.total}
                                            pageRangeDisplayed={5}
                                            onChange={this.handleItemsPageChange}
                                            itemClass='page-item'
                                            linkClass='page-link'
                                            prevPageText='Pre'
                                            nextPageText='Next'
                                            firstPageText='First'
                                            lastPageText='Last'
                                            innerClass="dataTables_paginate"
                                            linkClass="paginate_button"
                                            activeLinkClass="paginate_button current"
                                            disabledClass="paginate_button disabled"
                                        />
                                    </div>
                                )}
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>

                                {this.state.btnIsEnable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button
                                        type="button" class="custom-btn sm-btn gradiant-btn"
                                        disabled={items.length > 0 ? false : true}
                                        onClick={this.props.id ? this.addItemsToCollection : this.addItemsInfoToCollection}
                                    >
                                        {this.state.btnIsEnable ? "Loading..." : "Add Items"}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>


                {/* ----- View Items Modal ----- */}
                <div class="actionModal modal fade" id="itemsListView" tabindex="-1" role="dialog" aria-labelledby="itemsListView" aria-hidden="true">
                    <Loader />
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">View Items</h5>
                            </div>

                            <div class="modal-body">
                                {this.state.modal_error_message &&
                                    <Notification
                                        type={this.state.modal_error_type}
                                        message={this.state.modal_error_message}
                                        callback={this.removeNetworkError}
                                    />
                                }

                                {collections.length > 0 ? (
                                    <div class="select-tbl table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        {/* <div class="form-check" style={{ left: '-4px' }}>
                                                            <input type="checkbox" class="check-form-input" id="checkbox" checked="" />
                                                            <span class="checkmark"></span>
                                                        </div> */}
                                                    </th>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">Thumbnail</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Code</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {collections.map((collection, i) => (
                                                    <tr key={i}>
                                                        <td scope="row">
                                                            <div class="form-check">
                                                                <input type="checkbox" class="check-form-input" id="checkbox"
                                                                    checked={this.state.selectedItems[collection.id] !== undefined}
                                                                    onChange={(e) => this.handleSelectedItemsChange(e.target.checked, collection.id)}
                                                                />
                                                                <span class="checkmark"></span>
                                                            </div>
                                                        </td>
                                                        <td scope="row">{collection.id}</td>
                                                        <td>
                                                            <div class="logoImg">
                                                                <img src={collection.thumbnail_url ? collection.thumbnail_url : null} alt="" class="img-fluid" />
                                                            </div>
                                                        </td>
                                                        <td class="name">{collection.name ? collection.name : null}</td>
                                                        <td>{collection.code ? collection.code : null}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <Notification
                                        type="danger" message="No item selected." callback={this.removeNetworkError}
                                    />
                                )}
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                <button type="button" class="custom-btn sm-btn gradiant-btn"
                                    disabled={jQuery.isEmptyObject(selectedItems) ? true : false} data-toggle="modal" data-target="#itemDeleteModal">Remove Items</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete Brand Card Modal */}
                <div class="actionModal modal fade" id="itemDeleteModal" tabindex="-1" role="dialog" aria-labelledby="itemDeleteModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirm collection items Deletion</h5>
                            </div>

                            <div class="modal-body">
                                <p class="modal-msg">You are about to delete the collection items.</p>
                                <p><strong>Do you want to proceed?</strong></p>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>

                                {this.state.btnIsEnable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button type="button" class="custom-btn sm-btn gradiant-btn"
                                        onClick={this.removeItemsFromCollection}
                                    >
                                        {this.state.btnIsEnable ? "Loading..." : "Delete"}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        collections: state.collections,
        rewards: state.rewards,
        badges: state.badges,
        brands: state.brands,
        items: state.items,
        total: state.itemMeta.total,
        limit: state.itemMeta.limit,
        isLoading: state.itemMeta.isLoading,
        page: state.itemMeta.page,
        no_Of_pages: state.itemMeta.no_Of_pages,
        search: state.itemMeta.search,
        reward_total: state.fetchRewardsMeta.total,
        reward_isLoading: state.fetchRewardsMeta.isLoading,
        reward_page: state.fetchRewardsMeta.page,
        reward_limit: state.fetchRewardsMeta.limit,
        reward_search: state.fetchRewardsMeta.search,
        reward_no_Of_pages: state.fetchRewardsMeta.no_Of_pages,
        badge_total: state.fetchBadgesMeta.total,
        badge_isLoading: state.fetchBadgesMeta.isLoading,
        badge_page: state.fetchBadgesMeta.page,
        badge_limit: state.fetchBadgesMeta.limit,
        badge_search: state.fetchBadgesMeta.search,
        badge_no_Of_pages: state.fetchBadgesMeta.no_Of_pages
    };
};

const mapDispatchToProps = {
    fetchLookups,
    addCategories,
    addTypes,
    getAll,
    destroy,
    getRewards,
    getBadges,
    addCollection,
    editCollection
};

export default connect(mapStateToProps, mapDispatchToProps)(Create);